<template>
  <header :class="{'header--hidden': !showHeader}">
    <div class="logo_container">
      <router-link to="/" @click="scrollToTop">
        <div class="img-container">
          <img class="img" src="../assets/logos/Satertriathlon_logo_svart.jpg"/>
        </div>
      </router-link>
    </div>
    <nav>
      <router-link to="/" @click="scrollToTop">HEM</router-link> |
      <router-link to="/registration">ANMÄLAN</router-link> |
      <router-link to="/results">RESULTAT</router-link> |
      <router-link to="/participant">DELTAGARE</router-link> |
      <router-link to="/audience">PUBLIK</router-link> |
      <!-- <router-link to="/">CUPEN</router-link> |
      <router-link to="/">CREW</router-link> |
      <router-link to="/">PARTNERS</router-link> | -->
      <router-link to="/about">KONTAKT</router-link>
      </nav>
      <Slide :closeOnNavigation="true" right class="burger">
        <router-link to="/" @click="scrollToTop">HEM</router-link>
        <router-link to="/registration">ANMÄLAN</router-link>
        <router-link to="/results">RESULTAT</router-link>
        <router-link to="/participant">DELTAGARE</router-link>
        <router-link to="/audience">PUBLIK</router-link>
        <router-link to="/about">KONTAKT</router-link>
      </Slide>
  </header>
</template>

<script>
import { Slide } from 'vue3-burger-menu'
export default {
  name: 'Header',
  components: {
    Slide
  },
  data() {
    return {
      showHeader: true,
      lastScrollPosition: 0,
      // isOpen: false
    }
  },

  methods: {
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 400) {
        return
      }
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 5) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition < this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    },
    scrollToTop() {
      window.scrollTo(0,0);
    }
  },

  mounted () {
    window.addEventListener('scroll', this.onScroll)
  }
  // beforeDestroy () {
  //   window.removeEventListener('scroll', this.onScroll)
  // }
}
</script>

<style lang="scss" scoped>
  header {
    width: 100%;
    height: 80px;
    // margin: 0 auto 20px;
    padding: 0 5%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    position: fixed;
    z-index: 2;
    background-color: white;
    transform: translate3d(0, 0, 0);
    transition: 0.1s all ease-out;
  }
  
  .burger {
    .bm-menu {
      height: 100vh;
      color: white;

      a {
        color: white;
      }

      nav a.router-link-exact-active {
        color: #4289b9;
      }
    }
    @media only screen and (min-width: 750px) {
      display: none;
    }
  }

  .header--hidden {
    box-shadow: none;
    transform: translate3d(0, -100%, 0);
  }

  nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  a {
    padding:10px;
  }
  @media only screen and (max-width: 750px) {
    display: none;
  }
  a {
    font-weight: bold;
    color: #000000;

    &.router-link-exact-active {
      color: #4289b9;
    }
  }
}

  .logo_container {
    padding: 10px;
    display: flex;
    justify-content: space-between;

    @media only screen and (max-width: 750px) {
      height: 50%;
      margin-top: 10px;
    }
    @media only screen and (max-width: 550px) {
      height: 40%;
      margin-top: 15px;
    }
  }
  .img-container {
    height: 100%;
    margin-right: 20px;
    img { 
      width:100%;
      height:100%;
    }
  }
</style>